import Component from 'can/component/component';
import template from './strokes-text.stache';

Component.extend({
    tag: 'strokes-text-chart',
    template: template,
    leakScope: false,
    viewModel: {
        define: {
            title: {
                type: 'string',
            },
            modalTitle: {
                type: 'string',
            },
            subName: {
                type: 'string',
            },
            name: {
                type: 'string',
            },
            description: {
                type: 'string',
            },
            rank: {
                type: 'string',
            },
            value: {
                type: 'string',
            },
        },
    },
});
